interface FirebaseAuthErrorLike {
  code?: string;
  message?: string;
}

export function shouldFallbackToGoogleRedirect(error: unknown): boolean {
  const authError = (error ?? {}) as FirebaseAuthErrorLike;
  const code = authError.code ?? '';

  return (
    code === 'auth/popup-closed-by-user' ||
    code === 'auth/popup-blocked' ||
    code === 'auth/cancelled-popup-request'
  );
}

export function getGoogleAuthErrorMessage(error: unknown): string {
  const authError = (error ?? {}) as FirebaseAuthErrorLike;
  const code = authError.code ?? '';
  const message = authError.message ?? '';

  if (code === 'auth/popup-closed-by-user') {
    return 'Sign-in cancelled. Please try again and complete the sign-in process.';
  }

  if (code === 'auth/popup-blocked') {
    return '⚠️ Pop-up blocked. Allow pop-ups for this site in your browser settings, then try again.';
  }

  if (code === 'auth/unauthorized-domain') {
    return '⚠️ This domain is not authorized in Firebase. Add this domain in Firebase Console → Authentication → Settings → Authorized domains.';
  }

  if (
    code === 'auth/operation-not-allowed' ||
    code === 'auth/configuration-not-found' ||
    code === 'auth/invalid-credential' ||
    code === 'auth/internal-error'
  ) {
    return '⚠️ Firebase configuration error: enable Google Sign-In in Firebase Console → Authentication → Sign-in method → Google, set a project support email, and save.';
  }

  if (message.toLowerCase().includes('network')) {
    return '⚠️ Network error. Check your internet connection and try again.';
  }

  return `Google sign-in failed: ${message || 'Unknown error. Please try again or contact support.'}`;
}
